import { CertificateStatus } from '@/@types/generated'

interface ReRegisterableCertificate {
  status?: CertificateStatus
  isInterstate?: boolean
}

/**
 * Revoked and Voluntarily Surrendered certificates go through the
 * re-registration flow (RenewalAction.ReRegister) rather than a standard
 * renewal — see Certificate.IsReRegisterable on the backend.
 *
 * Eligibility is based on status alone, with no timeframe cutoff — mirrors
 * the backend's BypassesLateRenewalWindow, which now covers both statuses.
 * (A Revoked certificate can still be independently promoted to RedBanner by
 * the nightly scheduler job once 180 days pass, which is a separate
 * re-activation flow, not re-registration.)
 *
 * Unlike isRenewable, interstate carriers are NOT excluded here — an interstate
 * carrier can still re-register a Revoked/VoluntarilySurrendered certificate,
 * they just can't do a standard renewal (see CertificateController.GetCertificateRenewalFees
 * and CertificateService.RenewCertificateAsync, which allow IsInterstate through
 * only when IsReRegisterable).
 */
export function isReRegisterableCertificate(
  certificate: ReRegisterableCertificate | undefined
): boolean {
  return (
    certificate?.status === CertificateStatus.VOLUNTARILY_SURRENDERED ||
    certificate?.status === CertificateStatus.REVOKED
  )
}
